import Reveal from "./ui/Reveal";

const steps = [
    {
        title: "Evaluación",
        description: "Analizamos tu caso y verificamos la situación del predio."
    },
    {
        title: "Desarrollo Técnico",
        description: "Elaboramos planos, documentos y expediente técnico."
    },
    {
        title: "Gestión del Trámite",
        description: "Realizamos los procesos necesarios ante municipalidad o registros."
    },
    {
        title: "Entrega Final",
        description: "Recibes tu expediente listo y formalizado."
    }
];

const ProcessSection = () => {
    return (
        <section className="py-24 bg-gray-50">

            <div className="max-w-7xl mx-auto px-6">

                <Reveal>
                    <h2 className="text-3xl font-bold text-center text-[#1C1C1C]">
                        Nuestro Proceso de Trabajo
                    </h2>
                </Reveal>

                <div className="grid md:grid-cols-4 gap-8 mt-16">

                    {steps.map((step, index) => (
                        <Reveal key={index}>
                            <div className="text-center">

                                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#F26B1D] text-white font-bold mx-auto">
                                    {index + 1}
                                </div>

                                <h3 className="mt-4 font-semibold text-[#1C1C1C]">
                                    {step.title}
                                </h3>

                                <p className="mt-2 text-gray-600 text-sm">
                                    {step.description}
                                </p>

                            </div>
                        </Reveal>
                    ))}

                </div>

            </div>

        </section>
    );
};

export default ProcessSection;